import { type LeftTop, type Rect } from "@client/types";

export const AllowOffScreen = {
  None: 0,
  Left: 1,
  Top: 2,
  Right: 4,
  Bottom: 8
};

export const adjustPosition = (lt: LeftTop, rect: Rect, bounds: Rect, allowOffBounds: number): LeftTop => {
  let { left, top } = lt;

  !(allowOffBounds & AllowOffScreen.Left) && (left = Math.max(bounds.left, left));
  !(allowOffBounds & AllowOffScreen.Right) && (left = Math.min(left, bounds.right - rect.width));

  !(allowOffBounds & AllowOffScreen.Top) && (top = Math.max(bounds.top, top));
  !(allowOffBounds & AllowOffScreen.Bottom) && (top = Math.min(top, bounds.bottom - rect.height));

  return {
    left,
    top
  };
};
